import { e as isVueComponent, _ as _defineProperty } from './helpers-8130329a.js';
import { onUpdated, h } from 'vue';

!!(process.env.NODE_ENV !== "production") ? Object.freeze({}) : {};
!!(process.env.NODE_ENV !== "production") ? Object.freeze([]) : [];
const cacheStringFunction = (fn) => {
  const cache = /* @__PURE__ */ Object.create(null);
  return (str) => {
    const hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
};
const camelizeRE = /-(\w)/g;
const camelize = cacheStringFunction((str) => {
  return str.replace(camelizeRE, (_, c) => c ? c.toUpperCase() : "");
});
const hyphenateRE = /\B([A-Z])/g;
const hyphenate = cacheStringFunction(
  (str) => str.replace(hyphenateRE, "-$1").toLowerCase()
);
const capitalize = cacheStringFunction(
  (str) => str.charAt(0).toUpperCase() + str.slice(1)
);
const toHandlerKey = cacheStringFunction(
  (str) => str ? `on${capitalize(str)}` : ``
);

var SlotComponent = {
  name: 'BSlotComponent',
  props: {
    component: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      default: 'default'
    },
    scoped: {
      type: Boolean
    },
    props: {
      type: Object
    },
    tag: {
      type: String,
      default: 'div'
    },
    event: {
      type: String,
      default: 'vue:updated'
    }
  },
  data: function data() {
    return {
      updatedHook: undefined,
      handlerKey: undefined
    };
  },
  methods: {
    refresh: function refresh() {
      this.$forceUpdate();
    }
  },
  created: function created() {
    if (isVueComponent(this.component)) {
      if (this.event === 'vue:updated') {
        // lifecycle event cannot be captured as an ordinary event
        this.updatedHook = onUpdated(this.refresh, this.component.$);
      } else {
        // directly manipuates the VNode
        // because Vue 3 no longer provides $on
        var vnode = this.component.$.vnode;
        var handlerKey = toHandlerKey(this.event);
        if (vnode.props == null) {
          vnode.props = _defineProperty({}, handlerKey, this.refresh);
        } else {
          var props = vnode.props;
          if (props[this.handlerKey] == null) {
            // tries camelCase
            handlerKey = toHandlerKey(camelize(this.event));
            if (props[handlerKey] == null) {
              // tries kebab-case
              handlerKey = toHandlerKey(hyphenate(this.event));
            }
          }
          if (props[handlerKey] == null) {
            handlerKey = toHandlerKey(this.event);
            props[handlerKey] = this.refresh;
          } else {
            // multiple handlers may be specified in an array
            if (Array.isArray(props[handlerKey])) {
              props[handlerKey].push(this.refresh);
            } else {
              props[handlerKey] = [props[handlerKey], this.refresh];
            }
          }
        }
        this.handlerKey = handlerKey;
      }
    }
  },
  beforeUnmount: function beforeUnmount() {
    if (isVueComponent(this.component)) {
      if (this.updatedHook != null) {
        // unfortunately, there is no counterpart of `onUpdated`.
        // so directly manipulates the internal instance.
        // see https://github.com/vuejs/core/blob/2ffe3d5b3e953b63d4743b1e2bc242d50916b545/packages/runtime-core/src/apiLifecycle.ts#L17-L64
        var index = this.component.$.u.indexOf(this.updatedHook);
        if (index !== -1) {
          this.component.$.u.splice(index, 1);
        }
      } else if (this.handlerKey != null) {
        // directly maniputates VNode
        // because Vue 3 no longer provides $off
        var props = this.component.$.vnode.props;
        if (props != null) {
          if (Array.isArray(props[this.handlerKey])) {
            var _index = props[this.handlerKey].indexOf(this.refresh);
            if (_index > -1) {
              props[this.handlerKey].splice(_index, 1);
              if (props[this.handlerKey].length === 1) {
                props[this.handlerKey] = props[this.handlerKey][0];
              }
            }
          } else {
            delete props[this.handlerKey];
          }
        }
      }
    }
  },
  render: function render() {
    return h(this.tag, {}, this.component.$slots ? this.scoped ? this.component.$slots[this.name](this.props) : this.component.$slots[this.name]() : undefined);
  }
};

export { SlotComponent as S };
